import { createFileRoute } from '@tanstack/react-router'
import termsMarkdown from '@/content/terms.md?raw'
import { LegalMarkdown } from '@/components/LegalMarkdown'

export const Route = createFileRoute('/terms-of-service')({
  head: () => ({
    meta: [
      { title: 'Terms of Service — Halo Compliance' },
      { name: 'robots', content: 'noindex' },
      { property: 'og:title', content: 'Terms of Service — Halo Compliance' },
      { property: 'og:url', content: 'https://www.halocompliance.com/terms-of-service' },
    ],
    links: [{ rel: 'canonical', href: 'https://www.halocompliance.com/terms-of-service' }],
  }),
  component: TermsPage,
})

function TermsPage() {
  return (
    <div className="marketing-inner py-5">
      <div className="container py-4">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <LegalMarkdown markdown={termsMarkdown} />
          </div>
        </div>
      </div>
    </div>
  )
}
